
export const SUBPORTION_TYPES = {
    SLIDE: { key: 'SLIDE', icon: 'icon-porta' }
}
